module.exports = __webpack_public_path__ + "static/media/smartAsn-logos-KASN.b180d567.svg";